import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { AdScheduleTemplate } from '@/hooks/useAdScheduleTemplates'
import { Loader2 } from 'lucide-react'

interface DeleteTemplateDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  template: AdScheduleTemplate
  onConfirm: () => void
  isDeleting?: boolean
}

export default function DeleteTemplateDialog({
  open,
  onOpenChange,
  template,
  onConfirm,
  isDeleting = false,
}: DeleteTemplateDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>確認刪除廣告排班模版</AlertDialogTitle>
          <AlertDialogDescription>
            確定要刪除「{template.template_name}」嗎？此操作無法復原。
            <br />
            <br />
            此模版包含 {template.slots.filter((s) => s.is_active).length} 個梯次。
            刪除後，已套用此模版的診所和設備將不受影響。
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>取消</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            刪除
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
